import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button/Button';
import styles from './StudyApproved.module.css';

const StudyApproved = () => {
  return (
    <div className={styles.centerContainer}>
      <div className={styles.contentBox}>
        <div className={styles.iconCircle}>
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#15803D" strokeWidth="2.2">
            <path d="m5 12 5 5 9-10" />
          </svg>
        </div>

        <h1 className={styles.title}>Study approved and live</h1>

        <p className={styles.description}>
          Mobile Gaming Behaviour is now visible to about 3,200 matching participants. Insight Loop Research has been notified.
        </p>

        <div className={styles.detailsCard}>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Approved by</span>
            <span className={styles.detailValue}>Nishant K.</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Incentives held from wallet</span>
            <span className={styles.detailValue}>₹60,000</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Service fee (Pro, 10%)</span>
            <span className={styles.detailValue}>₹6,000</span>
          </div>
        </div>

        <div className={styles.buttonGroup}>
          <Link to="/approvals">
            <Button variant="secondary">Back to queue</Button>
          </Link>
          <Link to="/study-review">
            <Button variant="primary">Review next study</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StudyApproved;
